/* eslint-disable */
import current from "@/apollo/auth/current.gql";
import login from "@/apollo/auth/login.gql";
import user_login_as from "@/apollo/auth/user_login_as.gql";

export const state = () => ({
  user: null,
  userLogging: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 15 Jun 2023 | 09:06PM
   * @param {*} state
   * @param {*} value
   */
  setUser: (state, value) => {
    state.user = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 15 Jun 2023 | 09:06PM
   * @param {*} state
   * @param {*} value
   */
  setUserLogging: (state, value) => (state.userLogging = value),

  /**
   * @description
   * @author Saurabh Jangra
   * @date 15 Jun 2023 | 09:06PM
   * @param {*} state
   */
  clearUser: (state) => (state.user = null)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 15 Jun 2023 | 09:06PM
   * @param {*} { commit }
   */
  fetchCurrentUser({ commit }) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: current }).then(({ data }) => {
        if (data?.fetch_current_user) {
          resolve(data?.fetch_current_user);
          commit("setUser", data?.fetch_current_user);
        }
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 15 Jun 2023 | 09:06PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  loginUser({ commit }, payload) {
    commit("setUserLogging", true);
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .mutate({ mutation: login, variables: { ...payload } })
        .then(({ data }) => {
          if (data.login_user) {
            resolve(data.login_user);
            commit("setUserLogging", false);
          }
        })
        .catch((err) => {
          reject(err);
          commit("setUserLogging", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 16 Jun 2023 | 04:45PM
   * @param {*} { commit }
   * @param {*} _id
   * @returns {*}
   */
  userLoginAs({ commit }, _id) {
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .mutate({ mutation: user_login_as, variables: { _id } })
        .then(({ data }) => {
          if (data.user_login_as) {
            localStorage.setItem("token", data.user_login_as);
            window.location.href = "/";
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 15 Jun 2023 | 09:06PM
   * @param {*} _
   */
  logoutUser(_) {
    localStorage.removeItem("token");
    window.location.reload();
  }
};

export const getters = {
  user: (state) => state.user,
  userLogging: (state) => state.userLogging
};
